import React from 'react';
import { SvgIcon } from '@mui/material';

const SvgIdentityCheck = (props) => (
  <SvgIcon {...props} title="IdentityCheck">
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#Identity-Check_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.495.111C.6.427 0 1.253 0 2.166c0 1.105 1.388 1.173 1.524.076a.787.787 0 0 1 .443-.637l.209-.105h19.648l.208.105c.256.13.407.347.443.637C22.611 3.339 24 3.27 24 2.166c0-.913-.6-1.74-1.495-2.055l-.31-.109H1.804l-.31.11Zm0 4.5a2.234 2.234 0 0 0-1.4 1.43c-.15.45-.15 15.971.001 16.42a2.253 2.253 0 0 0 1.446 1.443c.463.157 3.899.147 4.134-.011.191-.128.311-.353.348-.651.126-1.016 1.472-.88 1.476.149 0 .165.159.406.34.516.239.145 8.081.145 8.32 0 .18-.11.34-.352.34-.516.004-1.03 1.35-1.165 1.475-.15.037.299.158.524.348.652.237.159 3.671.168 4.138.01a2.253 2.253 0 0 0 1.443-1.445c.15-.446.15-15.97 0-16.416a2.234 2.234 0 0 0-1.4-1.43l-.309-.11H1.804l-.31.11Zm20.513 1.477c.23.106.34.226.424.46.084.235.1 15.063.016 15.364-.142.51-.387.587-1.88.588h-1.159l-.13-.267c-.807-1.65-3.251-1.65-4.058 0l-.13.267H8.909l-.13-.267c-.807-1.65-3.251-1.65-4.058 0l-.13.267H3.43c-1.493 0-1.737-.077-1.88-.588-.083-.301-.067-15.129.017-15.364a.707.707 0 0 1 .424-.46c.293-.134 19.723-.134 20.016 0ZM7.37 7.594c-2.698.707-3.407 4.45-1.14 6.02.244.17.244.171-.08.296-1.77.687-3.147 2.722-3.15 4.652 0 .505.07.68.34.845.24.146 9.58.146 9.82 0 .27-.165.34-.34.339-.845-.002-1.93-1.38-3.965-3.15-4.652-.323-.125-.323-.127-.08-.296 1.057-.732 1.6-2.282 1.264-3.6-.459-1.792-2.354-2.894-4.163-2.42Zm1.166 1.453c1.477.276 2.062 2.006 1.046 3.092-1.044 1.116-2.88.536-3.163-1-.168-.905.55-1.901 1.503-2.088.293-.057.33-.057.614-.004Zm5.303 1.546c-.462.282-.462 1.031 0 1.313.238.146 5.083.146 5.321 0 .463-.282.463-1.03 0-1.313-.238-.145-5.083-.145-5.32 0Zm0 3c-.462.282-.462 1.031 0 1.313.24.146 6.583.146 6.821 0 .463-.282.463-1.03 0-1.313-.238-.145-6.582-.145-6.82 0ZM9.081 15.12c1.318.298 2.495 1.456 2.797 2.751l.03.129H4.592l.03-.129c.348-1.497 1.66-2.62 3.323-2.842.22-.03.814.018 1.136.09Z"
          fill="#017163"
        />
      </g>
      <defs>
        <clipPath id="Identity-Check_svg__a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);

export default SvgIdentityCheck;
